import { combineReducers } from 'redux';

import ListadoCursosReducer from './listado_cursos_reducer';
import BuyDetailsReducer from './buy_details_reducer';
import EncabezadoReducer from './encabezado_reducer';
import CarritoReducer from './carrito_reducer';
import ModuloReducer from './modulo_reducer';
import LeidosReducer from './leidos_reducer';
import LoginReducer from './login_reducer';
import CursoReducer from './curso_reducer';

const rootReducer = combineReducers(
  {
    usuario: LoginReducer,
    curso: CursoReducer,
    modulo: ModuloReducer,
    listado_cursos: ListadoCursosReducer,
    encabezado: EncabezadoReducer,
    carrito: CarritoReducer,
    buyDetail: BuyDetailsReducer,
    leidos: LeidosReducer
  }
);

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js